import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { PastBookingsStore, NewBookingsStore, RootStore } from 'AppClient/stores';
import NoBookingInfo from 'AppClient/components/NoBookingInfo';
import { Collapse } from 'components/antd';
import TableBuilder from 'components/TableBuilder/TableBuilder';
import BookingFeedbackModal from '../BookingFeedbackModal';

import getColumnsWithRender from './getColumnsWithRender';

import styles from './styles.module.scss';

import { toJS } from 'mobx';

interface Props {
	pastBookingsStore?: PastBookingsStore;
	newBookingsStore?: NewBookingsStore;
}
@inject(({ pastBookingsStore, newBookingsStore }: RootStore) => ({
	pastBookingsStore,
	newBookingsStore,
}))
@observer
export class PastBookingTable extends Component<Props> {
	render() {
		const {
			getTotalCount,
			pastBookingsData,
			isIdle,
			isPending,
			isData,
			bookingFeedback,
		} = this.props.pastBookingsStore!;
		const { editPastBooking } = this.props.newBookingsStore!;
		const isLoading = isIdle || isPending;

		return (
			<>
				<Collapse defaultActiveKey={['1']}>
					<Collapse.Panel header="PAST" key={'1'}>
						{!isData && isLoading ? null : !isData ? (
							<NoBookingInfo message="No past bookings yet" />
						) : (
							<div className={styles.tableReadOnly}>
								<TableBuilder
									columns={getColumnsWithRender({
										onRating: bookingFeedback,
										onBookAgain: editPastBooking,
									})}
									orderByAscending={false}
									data={toJS(pastBookingsData)}
									isLoading={false}
									dataTotal={getTotalCount}
									onRetrieveData={this.props.pastBookingsStore!.setRequestParams}
									initialOrderColumn="PickUpDateTime"
									scroll={{ x: 1303 }}
								/>
							</div>
						)}
					</Collapse.Panel>
				</Collapse>
				<BookingFeedbackModal />
			</>
		);
	}
}
